'use client';
import React from 'react';
import { useThemeStore } from '@/modules/shared/stores/useThemeStore';

const Layout_bg = () => {
  const { mode } = useThemeStore();
  const isDark = mode === 'Dark';
  return (
    <>
      {!isDark ? (
        <div
          className='absolute inset-0 bg-cover bg-center bg-no-repeat'
          style={{
            backgroundImage: 'url(/bg_orth.jpg)',
          }}
        />
      ) : (
        <div
          className='absolute inset-0 bg-cover bg-center bg-no-repeat'
          style={{
            background:
              ' linear-gradient(120deg,rgba(94, 94, 94, 1) 0%, rgba(0, 0, 0, 1) 19%)',
          }}
        />
      )}
    </>
  );
};

export default Layout_bg;
